import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Snow's Garden Center</h3>
            <p>
              Central Virginia's premier garden center and landscaping service. 
              Fourth-generation family tradition since 1912.
            </p>
            <p style={{ marginTop: 'var(--space-sm)' }}>
              <strong>Serving:</strong><br />
              Charlottesville • Albemarle • Fluvanna • Augusta Counties • Lake Anna
            </p>
          </div>
          
          <div className="footer-section">
            <h3>Quick Links</h3>
            <Link to="/services">Our Services</Link>
            <Link to="/about">About Us</Link>
            <Link to="/portfolio">Portfolio</Link>
            <Link to="/events">Events</Link>
            <Link to="/contact">Contact</Link>
          </div>
          
          <div className="footer-section">
            <h3>Services</h3>
            <Link to="/services">Residential Landscaping</Link>
            <Link to="/services">Commercial Landscaping</Link>
            <Link to="/services">Hardscaping</Link>
            <Link to="/services">Garden Center</Link>
            <Link to="/services">Design Services</Link>
            <Link to="/services">Lawn Care</Link>
          </div>
          
          <div className="footer-section">
            <h3>Contact Info</h3>
            <p>
              <strong>Address:</strong><br />
              1875 Avon Street Extended<br />
              Charlottesville, VA 22902
            </p>
            <p>
              <strong>Phone:</strong> <a href="tel:434-295-2159">(434) 295-2159</a><br />
              <strong>Email:</strong> <a href="mailto:tammy@snowknows.com">tammy@snowknows.com</a>
            </p>
            <div style={{ marginTop: 'var(--space-sm)' }}>
              <a href="https://www.facebook.com/snowsgardencenter" target="_blank" rel="noopener noreferrer">
                Facebook
              </a>
              <a href="https://www.instagram.com/snowsgardencenter/" target="_blank" rel="noopener noreferrer" style={{ marginLeft: 'var(--space-md)' }}>
                Instagram
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Snow's Garden Center. All rights reserved. | Established 1912</p>
          <p style={{ fontSize: 'var(--text-xs)', marginTop: 'var(--space-xs)' }}>
            Website by VMV Brands
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;